<template>
  <lu-vbox class='panel_container'>
    <SettingsPanel class="drag-handle" :dataExposureTotal='dataExposureTotal' :options='options' :panelId='panelId' :noPopup='noPopup'
      @selectedNoLimitPanel='onSelectedNoLimitPanel'
      @close='onClose'
      @expand='onExpand'
      @settings='onSettings'
      @fullscreen='onFullScreen'
      @exportexcel='onExportExcel'
      @changeBookFilter='onChangeBookFilter'
      @changeBookPnLMode='onChangeBookPnLMode'
      @changeLotsMios='onChangeLotsMios'
      @changeBookSet='onChangeBookSet'
      @changeShowNetExposure='onChangeShowNetExposure'>

      <template v-slot:options v-if='$scopedSlots.options'>
        <slot name='options'></slot>
      </template>

      <template v-slot:totalSlot v-if='panelId === "ccyExposure"'>
        <SettingsTotal :dataExposureTotal='dataExposureTotal' />
      </template>
    </SettingsPanel>

    <template v-if='panelId!=="ccyExposure"'>
      <div class='card-content' >
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <lu-scroll-area lu-flex :scrollbarWidth='15' >
        <div class='card-content' >
          <slot></slot>
        </div>
      </lu-scroll-area>
    </template>
  </lu-vbox>
</template>

<script>
import { LuVbox, LuScrollArea } from 'lusis-ui'
import utilsMixin from '@/mixins/utils'
import SettingsPanel from './components/settingsPanel'
import SettingsTotal from './components/settingsTotal'

export default {
  name: 'Panel',
  mixins: [ utilsMixin ],
  components: { LuVbox, LuScrollArea, SettingsPanel, SettingsTotal },
  props: {
    options: {
      type: Object,
      default: function() {
        return {
        }
      }
    },
    dataExposureTotal: {
      type: Object,
      default: function() {
        return {
        }
      }
    },
    noPopup: {
      type: Boolean,
      default: false
    },
    panelId: {
      type: String
    }
  },
  data: function () {
    return {
      isExpanded: true,
      clicked: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0
    }
  },
  computed: {
  },
  methods: {
    onExpand: function () {
      this.isExpanded = !this.isExpanded
    },
    onClose: function () {
      this.$emit('close', this.panelId)
    },
    onFullScreen: function () {
      this.$emit('fullscreen', this.panelId)
    },
    onSettings: function () {
      this.$emit('settings', this.panelId)
    },
    onExportExcel: function () {
      this.$emit('exportexcel', this.panelId)
    },
    onSelectedNoLimitPanel: function () {
      this.$emit('selectedNoLimitPanel')
    },
    onChangeBookFilter: function (bookFilterId, platform, bookName) {
      this.$emit('changeBookFilter', this.panelId, bookFilterId, platform, bookName)
    },
    onChangeBookPnLMode: function () {
      this.$emit('changeBookPnLMode', this.panelId)
    },
    onChangeLotsMios: function () {
      this.$emit('changeLotsMios', this.panelId)
    },
    onChangeBookSet: function (bookSet) {
      this.$emit('changeBookSet', this.panelId, bookSet)
    },
    onChangeShowNetExposure: function () {
      this.$emit('changeShowNetExposure', this.panelId)
    }

    /*,
    onDragStart: function (e) {
      e.dataTransfer.setData('panel', this.panelId)
      e.dataTransfer.effectAllowed = 'move'
      this.$emit('startDrag', this.panelId)
    },
    onDragEnd: function (e) {
      this.$emit('stopDrag', this.panelId)
    },
    onDragOver: function (e) {
      e.dataTransfer.dropEffect = 'move'
      e.preventDefault()
      this.$emit('dragOver', this.panelId)
    },
    onDrop: function (e) {
      e.preventDefault()
      this.$emit('drop', this.panelId)
    }
    */
  }
}
</script>

<style lang='scss'>
.panel_container {
  padding:10px;
  border: solid 1px #7e7e7e;
  border-radius: 5px;
}
</style>